import React from 'react';

interface SecretKeyModalProps {
  show: boolean;
  environment: 'test' | 'production';
  secretKey: string;
  isValidating: boolean;
  onClose: () => void;
  onEnvironmentChange: (env: 'test' | 'production') => void;
  onSecretKeyChange: (value: string) => void;
  onSubmit: () => void;
}

export const SecretKeyModal: React.FC<SecretKeyModalProps> = ({
  show,
  environment,
  secretKey,
  isValidating,
  onClose,
  onEnvironmentChange,
  onSecretKeyChange,
  onSubmit,
}) => {
  if (!show) return null;

  return (
    <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={e => e.stopPropagation()}>
      <div className="modal-dialog" style={{ maxWidth: '500px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Update and Test Stripe Connection</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <div className="form-group">
              <label>Environment</label>
              <select
                className="form-control"
                value={environment}
                onChange={(e) => onEnvironmentChange(e.target.value as 'test' | 'production')}
              >
                <option value="test">Test</option>
                <option value="production">Production</option>
              </select>
            </div>

            <div className="form-group" style={{ marginTop: '15px' }}>
              <label>Restricted Secret Key</label>
              <input
                type="password"
                className="form-control"
                value={secretKey}
                onChange={(e) => onSecretKeyChange(e.target.value)}
                placeholder={environment === 'test' ? 'rk_test_...' : 'rk_live_...'}
              />
              <small className="form-text text-muted">
                Enter your Stripe Restricted API Key (rk_*). It will be sent securely to the server for validation and connection testing.
                Never share or expose this key in client-side code.
              </small>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onSubmit}
              disabled={!secretKey || isValidating}
            >
              {isValidating ? 'Testing connection...' : 'Update and Test Connection'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};